<template>
    <loading v-model:active="isLoading" :can-cancel="false" :on-cancel="onCancel" :is-full-page="fullPage" />
    <div class="container-fluid">
        <div class="row">
            <div class="col-xl-7 col-md-7 col-xs-12 col-sm-12 mt-1">
                <router-link to="/receivable-account/new" class="btn btn-info"><i class="fa fa-plus"></i> Nova
                    receita</router-link>
            </div>
            <div class="col-xl-2 col-md-2 col-xs-12 col-sm-12 offset-xl-3 offset-md-3  mt-1 ">
                <div class="wrapper input-group">

                    <button class="btn btn-light ml-2 " @click="advancedSearch()"><i class="fa fa-align-justify"></i>
                        Busca avançada</button>
                </div>
            </div>
        </div>
        <div class="row mt-3" v-show="advanced_search">
            <div class="col-xl-12 col-md-12 col-xs-12 col-sm-12">
                <fieldset>
                    <div class="row">
                        <div class="col-xl-12 col-md-12 col-xs-12 col-sm-12">
                            <label for="">Descrição</label>
                            <input type="text" id="description" class="form-control"
                                placeholder="Ex: Conta a receber de xyz..." v-model="advanced_search_input.name">
                        </div>
                    </div>
                    <div class="row mt-2">
                        <div class="col-xl-6 col-md-6 col-xs-12 col-sm-12">
                            <label for="">Status</label>
                            <select class="form-control" v-model="advanced_search_input.status">
                                <option value="" selected>Todos os status, exceto canceladas</option>
                                <option value="Processando">Processando</option>
                                <option value="Pendente">Pendente</option>
                                <option value="Paga">Paga</option>
                                <option value="Cancelada">Cancelada</option>
                                <option value="chargedback">Chargedback</option>
                                <option value="Erro">Erro</option>
                                <option value="Em atraso">Em atraso</option>
                                <option value="Falha">Falha</option>
                            </select>
                        </div>
                        <div class="col-xl-6 col-md-6 col-xs-12 col-sm-12">
                            <label for="">Método de pagamento</label>
                            <select class="form-control" v-model="advanced_search_input.method">
                                <option value="" selected>Todos os métodos</option>
                                <option value="ticket">Apenas boletos</option>
                                <option value="pix">Apenas PIX</option>
                                <option value="ticket_pix">Apenas Boleto-Pix</option>
                                <option value="Dinheiro">Apenas dinheiro</option>
                                <option value="other">Outros</option>
                            </select>
                        </div>
                    </div>
                    <div class="row mt-2">
                        <div class="col-xl-6 col-md-6 col-xs-12 col-sm-12">
                            <label for="">Vencimento a partir de</label>
                            <input type="date" id="from" class="form-control"
                                v-model="advanced_search_input.due_date_from">
                        </div>
                        <div class="col-xl-6 col-md-6 col-xs-12 col-sm-12">
                            <label for="">Vencimento até</label>
                            <input type="date" id="to" class="form-control" v-model="advanced_search_input.due_date_to">
                        </div>
                    </div>
                    <div class="row mt-3">
                        <div class="col-xl-12 col-md-12 col-xs-12 col-sm-12">
                            <button class="btn btn-info" @click="executeAdvancedSearch()"> <i
                                    class="fas fa-search fa-sm"></i> Pesquisar</button>
                            <button class="btn btn-danger ml-2" @click="cleanAdvancedSearch()"> <i
                                    class="fas fa-times fa-sm"></i> Limpar</button>
                        </div>

                    </div>
                </fieldset>
            </div>
        </div>
        <div class="row mt-4">
            <div class="col-xl-12 col-md-12 col-sm-12">
                <div class="card shadow mb-4">
                    <!-- Card Header - Dropdown -->
                    <div class="card-header py-3 d-flex flex-row align-items-center justify-content-between">
                        <h6 class="m-0 font-weight-bold text-primary">Contas a receber <small><span
                                    v-if="total_itens > 0">| Total registros encontrados: {{ formatDecimal(total_itens)
                                    }}</span></small><br>
                        </h6>
                       <div class="dropdown mb-4">
                            <button class="btn btn-warning dropdown-toggle" type="button" id="dropdownMenuButton"
                                data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                Ações
                            </button>
                            <div class="dropdown-menu animated--fade-in" aria-labelledby="dropdownMenuButton">
                                <button class="dropdown-item" @click="refreshLoadData()"><i class="fa fa-undo"></i> Recarregar
                                    dados</button>
                                <button v-if="receivable_accounts.length > 0" class="dropdown-item" @click="exportReceivableAccountXlsx()"><i class="fas fa-file-excel"></i> Exportar .xlsx</button>
                                <button v-if="receivable_accounts.length > 0" class="dropdown-item" @click="exportReceivableAccountJson()"><i
                                        class="fa fa-file"></i> Exportar .json</button>
                            </div>
                        </div>
                    </div>
                    <div class="card-body" :class="receivable_accounts.length <=0? 'card-body-no-spaccing':''">
                        
                        <div class="table-responsive">
                             <h6 class="m-0 font-weight-bold"><span class="text-success">Total liquidado: <small>R$ {{ total_paid }}</small></span> | <span class="text-warning">Total Pendente: <small>R$ {{ total_pending }}</small></span> | <span class="text-danger">Total em atraso: <small>R$ {{ total_overdue }}</small></span> </h6><br>
                            <table class="table" id="dataTable" width="100%" cellspacing="0">
                                <thead>
                                    <tr>
                                        <th>Cliente / Documento</th>
                                        <th>Descrição</th>
                                        <th>Vencimento</th>
                                        <th class="text-center">Situação</th>
                                        <th class="text-center">Total</th>
                                        <th class="text-center">Descontos(%)</th>
                                        <th class="text-center">Multa</th>
                                        <th class="text-center">Juros(%)</th>
                                        <th class="text-center">Total a pagar</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(receivable_account) in receivable_accounts"
                                        :key="receivable_account.id">
                                        <td class="align-middle">
                                            {{ receivable_account.client.name }}<br>
                                            {{ receivable_account.client.document_formatted }}
                                        </td>
                                        <td class="align-middle">
                                            <span v-if="receivable_account.recurrence != ''"
                                                :tooltip="receivable_account.recurrence.total_installment > 0 ? 'Cobrança parcelada: ' + receivable_account.recurrence.generated_installments + ' / ' + receivable_account.recurrence.total_installment : 'Cobrança recorrente: ' + receivable_account.recurrence.generated_installments + 'ª Parcela'"><i
                                                    class="fa fa-undo"
                                                    v-if="receivable_account.recurrence != ''"></i></span> {{
                                                        receivable_account.description
                                                    }}  <button type="button" class="btn btn-link" v-if="receivable_account.original != '' && receivable_account.receipt != ''" @click="downloadFile(receivable_account.receipt.id)">(Comprovante)</button><br> 
                                            <span class="badge badge-secondary"><span
                                                    tooltip="Categoria associada à receita">{{
                                                        receivable_account.category.name }}</span></span>
                                            <span class="badge badge-warning ml-2"><span
                                                    tooltip="Método de pagamento">{{ receivable_account.method
                                                    }}</span></span>
                                            <span class="badge badge-dark ml-2"><span tooltip="Conta bancária">{{
                                                receivable_account.bank.name
                                                    }}</span></span>
                                        </td>
                                        <td class="align-middle">{{ receivable_account.due_date_formatted }} </td>
                                        <td class="align-middle text-center">
                                            <span class="badge " :class="badgeStatus(receivable_account.status)">{{
                                                receivable_account.status
                                                }}</span>
                                            <br v-if="receivable_account.status == 'Paga'"><span
                                                v-if="receivable_account.status == 'Paga'" class="badge badge-secondary"
                                                tooltip="Data pagamento">
                                                {{ receivable_account.payment_date_formatted }}
                                            </span>
                                        </td>
                                        <td class="text-center align-middle">{{ receivable_account.amount_formatted }}
                                            <br v-if="receivable_account.original != ''"><span class="badge badge-secondary" v-if="receivable_account.original != ''"  tooltip="Valor original">{{ receivable_account.original.total_receiver_formatted }}</span>
                                        </td>
                                        <td class="text-center align-middle">{{ receivable_account.discount_formatted }}
                                        </td>
                                        <td class="text-center align-middle">{{ receivable_account.fine_formatted }}
                                        </td>
                                        <td class="text-center align-middle">{{ receivable_account.interest_formatted }}
                                        </td>
                                        <td class="text-center align-middle">{{
                                            receivable_account.total_receiver_formatted }} </td>
                                        <td>
                                            <div class="dropdown">
                                                <button class="btn btn-primary dropdown-toggle" type="button"
                                                    id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true"
                                                    aria-expanded="false"
                                                    :disabled="(receivable_account.status == 'Cancelada' && receivable_account.recurrence == '') || (receivable_account.status == 'Paga' && receivable_account.recurrence == '')">
                                                    Ações
                                                </button>
                                                <div class="dropdown-menu animated--fade-in"
                                                    aria-labelledby="dropdownMenuButton">
                                                    <button class="dropdown-item"
                                                        v-if="receivable_account.payment.type == 'ticket' && (receivable_account.status == 'Pendente' || receivable_account.status == 'Em atraso')"
                                                        @click="viewTicket(receivable_account.id)">Ver
                                                        boleto</button>
                                                     <button class="dropdown-item"
                                                        v-if="receivable_account.payment.type == 'ticket_pix' && (receivable_account.status == 'Pendente' || receivable_account.status == 'Em atraso')"
                                                        @click="viewTicketPix(receivable_account.id)">Ver
                                                        boleto</button>
                                                    <button class="dropdown-item"
                                                        v-if="receivable_account.payment.type == 'ticket' || receivable_account.payment.type == 'ticket_pix' && (receivable_account.status == 'Pendente' || receivable_account.status == 'Em atraso')"
                                                        @click="copyDigitableLine(receivable_account.payment)">Copiar
                                                        linha digitável</button>
                                                    <button class="dropdown-item"
                                                        v-if="receivable_account.payment.type == 'pix' && receivable_account.status == 'Pendente'"
                                                        @click="viewPix(receivable_account.id)">Ver
                                                        PIX</button>
                                                    <button class="dropdown-item"
                                                        v-if="(receivable_account.payment.type == 'pix' || receivable_account.payment.type == 'ticket_pix') && receivable_account.status == 'Pendente'"
                                                        @click="copyKeyCopyPaste(receivable_account.payment)">Copiar
                                                        chave Copia e Cola</button>
                                                    <button class="dropdown-item"
                                                        v-if="(receivable_account.payment.type == 'ticket' || receivable_account.payment.type == 'pix' || receivable_account.payment.type == 'ticket_pix') && (receivable_account.status == 'Pendente' || receivable_account.status == 'Em atraso')"
                                                        @click="sendDuplicate(receivable_account.id)">Enviar segunda via</button>
                                                    <button type="button" class="dropdown-item"
                                                        v-if="receivable_account.status == 'Pendente' || receivable_account.status == 'Em atraso'"
                                                        @click="showModalLiquidatedReceivableAccount(receivable_account)">Liquidar
                                                        cobrança</button>
                                                    <button type="button" class="dropdown-item"
                                                        v-if="enableEditOrDeleteReceivableAccount(receivable_account)"
                                                        @click="showModalEditReceivableAccount(receivable_account)">Editar
                                                        cobrança</button>
                                                    <button type="button" class="dropdown-item"
                                                        v-if="enableEditOrDeleteRecurrenceReceivableAccount(receivable_account)"
                                                        @click="showModalEditRecurrenceReceivableAccount(receivable_account)">{{
                                                            title_installment }}</button>
                                                    <button type="button" class="dropdown-item"
                                                        v-if="enableEditOrDeleteReceivableAccount(receivable_account)"
                                                        @click="deleteReceivableAccount(receivable_account.id)">Cancelar</button>

                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr v-if="receivable_accounts.length > 0 && page > 1">
                                        <td colspan="10" class="align-middle text-center pt-5"> <button
                                                @click="loadData()" class="btn btn-info btn-sm"
                                                :disabled="!buttonPagination"><i class="fa fa-spinner"></i> Carregar
                                                mais registros</button></td>
                                    </tr>
                                    <tr v-show="receivable_accounts.length <= 0">
                                        <td colspan="10" class="text-center">Nenhum registro encontrado</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!--Atualizar cobrança-->
    <div id="modalDisplayEditReceivableAccount" class="modal" :style="{ display: modalDisplayEditReceivableAccount }">
        <div class="row">
            <div class="col-lg-12 col-sm-12 col-xs-12">
                <div class="modal-content border-left-primary">
                    <div class="row" v-if="enable_error_list">
                        <div class="col-xl-12 col-md-12 col-sm-12">
                            <div class="alert alert-danger">
                                <ol>
                                    <li v-for="(error, index) in errors" :key="index">{{ error[0] }}</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                    <div class="modal-header">
                        <h5 class="modal-title" id="newFileLabel">Atualizar receita<br></h5>
                        <button type="button" class="close" @click="closeModalEditReceivableAccount()">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <form @submit="update">
                        <div class="modal-body">
                            <div class="row mt-2">
                                <div class="col-xl-8 col-md-8 col-sm-12 mt-1">
                                    <label for="">Descrição do lançamento*</label>
                                    <input type="text" class="form-control" placeholder="Pagamento referente à..."
                                        v-model="receivable_account.description">
                                </div>
                                <div class="col-xl-4 col-md-6 col-sm-12 mt-1">
                                    <label for="">Data da competência*</label>
                                    <input type="date" class="form-control"
                                        v-model="receivable_account.competence_date">
                                </div>
                            </div>
                            <div class="row mt-2">
                                <div class="col-xl-3 col-md-3 col-sm-12 mt-1">
                                    <label for="">Valor do lançamento*</label>
                                    <input type="text" class="form-control" v-model.lazy="receivable_account.amount"
                                        v-money="money">
                                </div>
                                <div class="col-xl-3 col-md-3 col-sm-12 mt-1">
                                    <label for="">Desconto(%)*</label>
                                    <input type="text" class="form-control" v-model.lazy="receivable_account.discount"
                                        v-money="percentage">
                                </div>
                                <div class="col-xl-3 col-md-3 col-sm-12 mt-1">
                                    <label for="">Multa (R$)*</label>
                                    <input type="text" class="form-control" v-model.lazy="receivable_account.fine"
                                        v-money="money">
                                </div>
                                <div class="col-xl-3 col-md-3 col-sm-12 mt-1">
                                    <label for="">Juros(% a.m)*</label>
                                    <input type="text" class="form-control" v-model.lazy="receivable_account.interest"
                                        v-money="percentage">
                                </div>
                            </div>
                            <div class="row mt-2">
                                <div class="col-lg-4 col-sm-4 col-xs-12">
                                    <label for="">Categoria*</label>
                                    <multiselect v-model="category_multiselect" :options="categories_options"
                                        :custom-label="categoryWithLang" placeholder="Selecione uma opção"
                                        :select-label="'Clique para selecionar'" :deselect-label="'Clique para remover'"
                                        @select="handleSelectCategory">

                                        <template #noResult>
                                            Nenhuma categoria encontrada.
                                        </template>
                                    </multiselect>
                                </div>
                                <div class="col-lg-4 col-sm-4 col-xs-12">
                                    <label for="">Vencimento*</label>
                                    <input type="date" class="form-control" v-model="receivable_account.due_date">
                                </div>
                                <div class="col-lg-4 col-sm-4 col-xs-12">
                                    <label for="">Código de referência</label>
                                    <input type="text" class="form-control" placeholder="Ex: 0001"
                                        v-model="receivable_account.cod_reference">
                                </div>
                            </div>
                            <div class="row mt-2 mb-4">
                                <div class="col-lg-12 col-xs-12 col-sm-12">
                                    <label for="">Observações</label>
                                    <editorText :modelValue="receivable_account.observation"
                                        @update-text="updateObservation" placeholderSend="Sem observações"
                                        ref="observations_receivable_account">
                                    </editorText>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-danger" @click="closeModalEditReceivableAccount()"><i
                                    class="fa fa-ban"></i>
                                Fechar</button>
                            <button type="submit" :disabled='!isDisabled' class="btn btn-info"><i
                                    class="fa fa-save"></i>
                                Atualizar</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>

    <!--Atualizar recorrência-->
    <div id="modalDisplayEditRecurrenceReceivableAccount" class="modal"
        :style="{ display: modalDisplayEditRecurrenceReceivableAccount }">
        <div class="row">
            <div class="col-lg-12 col-sm-12 col-xs-12">
                <div class="modal-content border-left-primary">
                    <div class="row" v-if="enable_error_list">
                        <div class="col-xl-12 col-md-12 col-sm-12">
                            <div class="alert alert-danger">
                                <ol>
                                    <li v-for="(error, index) in errors" :key="index">{{ error[0] }}</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                    <div class="modal-header">
                        <h5 class="modal-title" id="newFileLabel">{{ title_installment }}<br>
                            <span class="badge badge-danger"
                                v-if="receivable_account.status == 'Finalizada'">Finalizada</span>
                            <span class="badge badge-success" v-if="receivable_account.status == 'Ativa'">Ativa</span>
                        </h5>
                        <button type="button" class="close" @click="closeModalEditRecurrenceReceivableAccount()">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <form @submit="updateRecurrence">
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-xl-12 col-md-12 col-sm-12 mt-1">
                                    <label for="">Descrição do lançamento*</label>
                                    <input type="text" class="form-control" placeholder="Pagamento referente à..."
                                        v-model="receivable_account.description">
                                </div>
                            </div>
                            <div class="row mt-2">
                                <div class="col-xl-3 col-md-3 col-sm-12 mt-1">
                                    <label for="">Valor do lançamento*</label>
                                    <input type="text" class="form-control" v-model.lazy="receivable_account.amount"
                                        v-money="money">
                                </div>
                                <div class="col-xl-3 col-md-3 col-sm-12 mt-1">
                                    <label for="">Desconto(%)*</label>
                                    <input type="text" class="form-control" v-model.lazy="receivable_account.discount"
                                        v-money="percentage">
                                </div>
                                <div class="col-xl-3 col-md-3 col-sm-12 mt-1">
                                    <label for="">Multa (R$)*</label>
                                    <input type="text" class="form-control" v-model.lazy="receivable_account.fine"
                                        v-money="money">
                                </div>
                                <div class="col-xl-3 col-md-3 col-sm-12 mt-1">
                                    <label for="">Juros(% a.m)*</label>
                                    <input type="text" class="form-control" v-model.lazy="receivable_account.interest"
                                        v-money="percentage">
                                </div>
                            </div>

                            <div class="row mt-2">
                                <div class="col-lg-6 col-sm-6 col-xs-12">
                                    <label for="">Categoria*</label>
                                    <multiselect v-model="category_multiselect" :options="categories_options"
                                        :custom-label="categoryWithLang" placeholder="Selecione uma opção"
                                        :select-label="'Clique para selecionar'" :deselect-label="'Clique para remover'"
                                        @select="handleSelectCategory">

                                        <template #noResult>
                                            Nenhuma categoria encontrada.
                                        </template>
                                    </multiselect>
                                </div>
                                <div class="col-lg-6 col-sm-6 col-xs-12">
                                    <label for="">Código de referência</label>
                                    <input type="text" class="form-control" placeholder="Ex: 0001"
                                        v-model="receivable_account.cod_reference">
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6 col-xl-6 col-sm-12 mt-1" v-if="receivable_account.repeat">
                                    <label for="">Cobrar sempre no*</label>
                                    <multiselect v-model="day_generate_receivable_multiselect"
                                        :options="day_generate_receivable_options" placeholder="Selecione uma opção"
                                        :select-label="'Clique para selecionar'" :deselect-label="'Clique para remover'"
                                        :custom-label="dayGenerateReceivableWithLang"
                                        @select="handleSelectDayGenerateReceivable">
                                        <template #noResult>
                                            Nenhum dia encontrado.
                                        </template>
                                    </multiselect>
                                </div>
                                <div class="col-md-6 col-xl-6 col-sm-12 mt-1" v-if="!receivable_account.repeat">
                                    <label for="">Parcelamento*</label>
                                    <multiselect v-model="installment_multiselect" :options="installments_options"
                                        placeholder="Selecione uma opção" :select-label="'Clique para selecionar'"
                                        :deselect-label="'Clique para remover'" :custom-label="installmentWithLang"
                                        @select="handleSelectInstallment">
                                        <template #noResult>
                                            Nenhum parcelamento encontrado.
                                        </template>
                                    </multiselect>
                                </div>
                                <div class="col-md-6 col-xl-6 col-sm-12 mt-1"
                                    v-if="receivable_account.installment > 1 || receivable_account.repeat">
                                    <label for="">Intervalo entre parcelas*</label>
                                    <multiselect v-model="interval_recurrence_multiselect"
                                        :options="interval_recurrence_options" placeholder="Selecione uma opção"
                                        :select-label="'Clique para selecionar'" :deselect-label="'Clique para remover'"
                                        :custom-label="intervalRecurrenceWithLang"
                                        @select="handleSelectIntervalRecurrence">
                                        <template #noResult>
                                            Nenhum intervalo encontrado.
                                        </template>
                                    </multiselect>

                                </div>
                                <div class="col-md-6 col-xl-6 col-sm-12 mt-1">
                                    <label for="">Forma de pagamento*</label>
                                    <multiselect v-model="method_multiselect" :options="methods_options"
                                        :custom-label="methodWithLang" placeholder="Selecione uma opção"
                                        :select-label="'Clique para selecionar'" :deselect-label="'Clique para remover'"
                                        @select="handleSelectMethod">

                                        <template #noResult>
                                            Nenhuma forma de pagamento encontrada.
                                        </template>
                                    </multiselect>
                                </div>
                                <div class="col-md-6 col-xl-6 col-sm-12 mt-1">
                                    <label for="">Conta de pagamento*</label>
                                    <multiselect v-model="bank_multiselect" :options="banks_options"
                                        :custom-label="bankWithLang" placeholder="Selecione uma opção"
                                        :select-label="'Clique para selecionar'" :deselect-label="'Clique para remover'"
                                        @select="handleSelectBank">

                                        <template #noResult>
                                            Nenhuma conta encontrada.
                                        </template>
                                    </multiselect>
                                </div>
                            </div>

                            <div class="row mt-2 mb-4">
                                <div class="col-lg-12 col-xs-12 col-sm-12">
                                    <label for="">Observações</label>
                                    <editorText :modelValue="receivable_account.observation"
                                        @update-text="updateObservation" placeholderSend="Sem observações"
                                        ref="observations_recurrence_receivable_account">
                                    </editorText>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-danger"
                                @click="closeModalEditRecurrenceReceivableAccount()"><i class="fa fa-ban"></i>
                                Fechar</button>
                            <button type="submit" :disabled='!isDisabledRecurrence' class="btn btn-info"><i
                                    class="fa fa-save"></i>
                                Atualizar</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
    <div id="modalDisplayLiquidatedReceivableAccount" class="modal"
        :style="{ display: modalDisplayLiquidatedReceivableAccount }">
        <div class="row">
            <div class="col-lg-12 col-sm-12 col-xs-12">
                <form @submit="liquidatedReceivableAccount">
                    <div class="modal-content border-left-primary">
                        <div class="modal-header">
                            <h5 class="modal-title" id="newFileLabel">Liquidar cobrança<br>
                                <span class="badge badge-info mt-1">Cliente: {{ receivable_account.client_name }} - {{ receivable_account.client_document }}</span>
                                <span class="ml-2 mt-1 badge" :class="receivable_account.status == 'Em atraso'?'badge-danger':'badge-warning'">Situação: {{ receivable_account.status }}</span>
                            </h5>
                            <button type="button" class="close" @click="closeModalLiquidatedReceivableAccount()">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-xl-8 col-md-8 col-sm-12 mt-1">
                                    <label for="">Descrição do lançamento*</label>
                                    <input type="text" class="form-control" placeholder="Pagamento referente à..."
                                        v-model="receivable_account.description">
                                </div>
                                 <div class="col-xl-4 col-md-4 col-sm-12 mt-1">
                                    <label for="">Data do pagamento*</label>
                                    <input type="date" class="form-control"
                                        v-model="receivable_account.payment_date">
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-4 col-xl-4 col-sm-12 mt-1">
                                    <label for="">Valor do lançamento*</label>
                                    <input type="text" class="form-control" v-model.lazy="receivable_account.amount"
                                        v-money="money">
                                </div>
                                <div class="col-md-4 col-xl-4 col-sm-12 mt-1">
                                    <label for="">Forma de pagamento*</label>
                                    <multiselect v-model="method_multiselect" :options="methods_options"
                                        :custom-label="methodWithLang" placeholder="Selecione uma opção"
                                        :select-label="'Clique para selecionar'" :deselect-label="'Clique para remover'"
                                        @select="handleSelectMethod">

                                        <template #noResult>
                                            Nenhuma forma de pagamento encontrada.
                                        </template>
                                    </multiselect>
                                </div>
                                <div class="col-md-4 col-xl-4 col-sm-12 mt-1">
                                    <label for="">Conta de pagamento*</label>
                                    <multiselect v-model="bank_multiselect" :options="banks_options"
                                        :custom-label="bankWithLang" placeholder="Selecione uma opção"
                                        :select-label="'Clique para selecionar'" :deselect-label="'Clique para remover'"
                                        @select="handleSelectBank">
                                        <template #noResult>
                                            Nenhuma conta encontrada.
                                        </template>
                                    </multiselect>
                                </div>
                            </div>
                             <div class="row mt-2">
                                <div class="col-sm-12 col-xs-12 col-lg-12">
                                    Comprovante <small>(Tamanho máximo: 5MB)</small>
                                    <input type="file" @change="handleFileChange">
                                </div>
                            </div>
                            <div class="row mt-3" v-if="receivable_account.size != ''">
                                <div class="col-sm-12 col-xs-12 col-lg-12">
                                    <small class="mt-5">Tamanho arquivo selecionado: {{ receivable_account.size }}</small>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-danger"
                                @click="closeModalLiquidatedReceivableAccount()"><i class="fa fa-ban"></i>
                                Cancelar</button>
                            <button type="submit" class="btn btn-info"
                                :disabled='!isDisabledLiquidatedReceivableAccount'><i class="fa fa-check"></i>
                                Liquidar cobrança</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>

</template>
<script>
import api from '@/api';
import { handleRequestErrors } from '@/handleErrors';
import Loading from 'vue-loading-overlay';
import editorText from '../util/editor-text.vue';
import { mask } from 'vue-the-mask'
import { VMoney } from 'v-money'
import Multiselect from 'vue-multiselect'

import 'vue-loading-overlay/dist/css/index.css';
import { capitalize } from '@/util';

export default {
    directives: { money: VMoney, mask },
    components: { Loading, editorText, Multiselect },
    data() {
        return {
            isLoading: true,
            fullPage: true,
            advanced_search: false,
            advanced_search_input: { status: '', method: '' },
            receivable_accounts: [],
            url_api: '',
            method_multiselect: '',
            category_multiselect: '',
            bank_multiselect: '',
            categories_options: [],
            banks_options: [],
            day_generate_receivable_multiselect: { type: '1', value: '1º dia do mês' },
            installment_multiselect: { type: '1', value: 'À vista' },
            interval_recurrence_multiselect: { type: 'monthly', value: 'Mensal' },
            page: 1,
            last_page: 1,
            total_itens: 0,
            title_installment: 'Editar recorrência',
            modalDisplayEditReceivableAccount: 'none',
            modalDisplayEditRecurrenceReceivableAccount: 'none',
            modalDisplayLiquidatedReceivableAccount: 'none',
            enable_error_list: false,
            total_paid:'R$ 0,00',
            total_pending:'R$ 0,00',
            total_overdue:'R$ 0,00',
            errors: [],
            receivable_account: {
                id: '',
                category_id: '',
                competence_date: '',
                description: '',
                amount: '',
                discount: '',
                fine: '',
                interest: '',
                cod_reference: '',
                due_date: '',
                observation: '',
                interval_recurrence: 'monthly',
                day_generate_receivable: 1,
                repeat: false,
                method: '',
                installment: 1,
                bank_id: '',
                status: '',
                payment_date: '',
                size:'',
                archive: null,
                client_name:'',
                client_document:'',
            },
            money: {
                decimal: ',',
                thousands: '.',
                prefix: 'R$ ',
                suffix: '',
                precision: 2,
                masked: false
            },
            percentage: {
                decimal: '.',
                thousands: '',
                prefix: '',
                suffix: '',
                precision: 2,
                masked: false
            },
            day_generate_receivable_options: [
                { type: 1, value: '1º dia do mês' },
                { type: 2, value: '2º dia do mês' },
                { type: 3, value: '3º dia do mês' },
                { type: 4, value: '4º dia do mês' },
                { type: 5, value: '5º dia do mês' },
                { type: 6, value: '6º dia do mês' },
                { type: 7, value: '7º dia do mês' },
                { type: 8, value: '8º dia do mês' },
                { type: 9, value: '9º dia do mês' },
                { type: 10, value: '10º dia do mês' },
                { type: 11, value: '11º dia do mês' },
                { type: 12, value: '12º dia do mês' },
                { type: 13, value: '13º dia do mês' },
                { type: 14, value: '14º dia do mês' },
                { type: 15, value: '15º dia do mês' },
                { type: 16, value: '16º dia do mês' },
                { type: 17, value: '17º dia do mês' },
                { type: 18, value: '18º dia do mês' },
                { type: 19, value: '19º dia do mês' },
                { type: 20, value: '20º dia do mês' },
                { type: 21, value: '21º dia do mês' },
                { type: 22, value: '22º dia do mês' },
                { type: 23, value: '23º dia do mês' },
                { type: 24, value: '24º dia do mês' },
                { type: 25, value: '25º dia do mês' },
                { type: 26, value: '26º dia do mês' },
                { type: 27, value: '27º dia do mês' },
                { type: 28, value: '28º dia do mês' },

            ],
            installments_options: [
                { type: 1, value: 'À vista' },
                { type: 2, value: '2x' },
                { type: 3, value: '3x' },
                { type: 4, value: '4x' },
                { type: 5, value: '5x' },
                { type: 6, value: '6x' },
                { type: 7, value: '7x' },
                { type: 8, value: '8x' },
                { type: 9, value: '9x' },
                { type: 10, value: '10x' },
                { type: 11, value: '11x' },
                { type: 12, value: '12x' },
            ],
            methods_options: [
                { type: 'pix', value: 'PIX' },
                { type: 'ticket', value: 'Boleto' },
                { type: 'money', value: 'Dinheiro' },
                { type: 'other', value: 'Outros' }
            ],
            interval_recurrence_options: [
                { type: 'monthly', value: 'Mensal' },
                { type: 'bimonthly', value: 'Bimestral' },
                { type: 'quarterly', value: 'Trimestral' },
                { type: 'semiannual', value: 'Semestral' },
                { type: 'annual', value: 'Anual' }
            ],
        }
    },
    computed: {
        isDisabled: function () {
            return this.receivable_account.description != '' && this.receivable_account.competence_date != '' && this.receivable_account.amount != '' && this.receivable_account.category_id != '' && this.receivable_account.due_date != '';
        },
        isDisabledRecurrence: function () {
            if (this.receivable_account.status == 'Finalizada') {
                return false;
            }
            return this.receivable_account.description != '' && this.receivable_account.amount != '' && this.receivable_account.category_id != '';
        },
        isDisabledLiquidatedReceivableAccount: function () {
            return this.receivable_account.description != '' && this.receivable_account.amount != '' && this.receivable_account.bank_id != '' &&  this.receivable_account.payment_date != '';
        },
        buttonPagination: function () {
            return this.page > 1;
        },
        badgeStatus() {
            return (status) => {
                if (status == 'Processando') {
                    return 'badge-warning'
                } else if (status == 'Pendente') {
                    return 'badge-info'
                } else if (status == 'Paga') {
                    return 'badge-success'
                } else if (status == 'Cancelada') {
                    return 'badge-danger'
                } else if (status == 'Cancelando') {
                    return 'badge-danger'
                } else if (status == 'chargedback') {
                    return 'badge-danger'
                } else if (status == 'Erro') {
                    return 'badge-danger'
                } else if (status == 'Em atraso') {
                    return 'badge-danger'
                } else if (status == 'Falha') {
                    return 'badge-danger'
                } else if (status == 'Negada') {
                    return 'badge-danger'
                }
                return 'badge-secondary'
            }
        }
    },
    methods: {
        onCancel() { },
        advancedSearch() {
            this.advanced_search = !this.advanced_search
        },
        closeAdvancedSearch() {
            this.advanced_search = false
        },
        updateObservation(observation) {
            this.receivable_account.observation = observation;
        },
        bankWithLang({ value }) {
            return value;
        },
        categoryWithLang({ value }) {
            return value;
        },
        handleSelectBank(option) {
            this.receivable_account.bank_id = option.key;

        },
        handleSelectCategory(option) {
            this.receivable_account.category_id = option.key;
        },
        executeAdvancedSearch() {
            this.page = 1;
            this.receivable_accounts = {};
            this.loadData();
        },
        cleanAdvancedSearch() {
            this.receivable_accounts = {}
            this.advanced_search_input = {}
            this.refreshLoadData();
        },

        viewTicket(id) {
            const url = process.env.VUE_APP_URL_API + '/payment-ticket/' + id + '/downloadFile';
            window.open(url, '_blank');
        },

         viewTicketPix(id) {
            const url = process.env.VUE_APP_URL_API + '/payment-ticket-pix/' + id + '/downloadFileTicketPix';
            window.open(url, '_blank');
        },

        copyDigitableLine(payment) {
            console.log(payment);
            window.navigator.clipboard.writeText(payment.data.code);
            this.$notify({
                title: "Sucesso",
                text: "Linha digitável copiada com sucesso!",
                type: 'success'
            });
        },

        viewPix(id) {
            const url = process.env.VUE_APP_URL_API + '/payment-pix/' + id + '/viewPix';
            window.open(url, '_blank');
        },

        copyKeyCopyPaste(payment) {
            window.navigator.clipboard.writeText(payment.data.key);
            this.$notify({
                title: "Sucesso",
                text: "Chave Copia e Cola copiada com sucesso!",
                type: 'success'
            });
        },
        sendDuplicate(id) {
            this.$confirm(
                {
                    message: 'Deseja enviar uma segunda via da cobrança ao cliente?',
                    button: {
                        no: 'Não',
                        yes: 'Sim'
                    },

                    callback: confirm => {
                        if (confirm) {
                            this.isLoading = true;
                            api.post('/receivable-account/'+id+'/sendDuplicate')
                                .then(() => {
                                    this.isLoading = false;
                                    this.$notify({
                                        title: "Sucesso",
                                        text: "Segunda via enviada com sucesso!",
                                        type: 'success'
                                    });
                                }).catch(error => {
                                    this.isLoading = false;
                                    if (error.status == 422) {
                                        let response_errors = error.response.data.errors;
                                        this.errors = response_errors;
                                        this.enable_error_list = true;
                                    }
                                    handleRequestErrors(error.status);
                                })
                        }
                    }
                }
            )
        },
          handleFileChange(event) {
            if (event.target.files[0] != undefined) {
                const sizeInBytes = event.target.files[0].size;
                const sizeInMB = sizeInBytes / (1024 * 1024);
                if (sizeInMB > 5) {
                    this.$notify({
                        title: "Informação",
                        text: "Seu arquivo excede o limite de envio. O máximo para envio são 5MB",
                        type: 'info'
                    });
                    this.receivable_account.archive = null;
                } else {
                    this.receivable_account.archive = event.target.files[0];
                }
                this.receivable_account.size = sizeInMB.toFixed(2) + 'MB';

            } else {
                this.receivable_account.size = '';
                this.receivable_account.archive = null;
            }

        },
        async getCategories() {
            this.isLoading = true;
            const response = api.get('/category')
                .then((response) => {
                    this.categories = response.data.data;
                    this.isLoading = false;
                }).catch(error => {
                    this.isLoading = false;
                    handleRequestErrors(error.status, error);
                })
            return response;
        },
        async getBank() {
            this.isLoading = true;
            this.isLoading = true;
            const response = api.get('/bank-account')
                .then((response) => {
                    this.banks = response.data.data;
                    this.isLoading = false;
                }).catch(error => {
                    this.isLoading = false;
                    handleRequestErrors(error.status, error);
                })
            return response;
        },
        methodWithLang({ value }) {
            return value;
        },

        dayGenerateReceivableWithLang({ value }) {
            return value;
        },
        installmentWithLang({ value }) {
            return value;
        },
        intervalRecurrenceWithLang({ value }) {
            return value;
        },

        handleSelectMethod(option) {
            this.receivable_account.method = option.type;
        },
        handleSelectDayGenerateReceivable(option) {
            this.receivable_account.day_generate_receivable = option.type;
        },
        handleSelectInstallment(option) {
            this.receivable_account.total_installment = option.type;

        },
        handleSelectIntervalRecurrence(option) {
            this.receivable_account.interval_recurrence = option.type;
        },

        formatDecimal(number) {
            return new Intl.NumberFormat().format(number)
        },

        refreshLoadData(){
            this.page = 1;
            this.loadData();
        },

        loadData() {
            this.isLoading = true;

            api.get('/receivable-account', {
                params: {
                    'name': this.advanced_search_input.name,
                    'status': this.advanced_search_input.status,
                    'method': this.advanced_search_input.method,
                    'due_date_from': this.advanced_search_input.due_date_from,
                    'due_date_to': this.advanced_search_input.due_date_to,
                    'page': this.page
                }
            })
                .then((response) => {
                    this.isLoading = false;
                    this.total_itens = response.data.total_itens;
                    this.last_page = response.data.last_page;
                    if (this.page <= 1) {
                        this.receivable_accounts = response.data.data;
                    } else {
                        this.receivable_accounts = this.receivable_accounts.concat(response.data.data);
                    }

                    if (this.page < response.data.last_page) {
                        this.page++;
                    } else {
                        this.page = 1;
                    }
                    this.total_paid = response.data.total_paid;
                    this.total_pending = response.data.total_pending;
                    this.total_overdue = response.data.total_overdue;

                }).catch(error => {
                    this.isLoading = false;
                    handleRequestErrors(error.status);
                })
        },
        update(event) {
            event.preventDefault();
            this.$confirm(
                {
                    message: 'Deseja confirmar a atualização da receita?',
                    button: {
                        no: 'Não',
                        yes: 'Sim'
                    },

                    callback: confirm => {
                        if (confirm) {
                            this.isLoading = true;
                            api.put('/receivable-account/' + this.receivable_account.id, this.receivable_account)
                                .then(() => {
                                    this.isLoading = false;
                                    this.$notify({
                                        title: "Sucesso",
                                        text: "Receita atualizada com sucesso",
                                        type: 'success'
                                    });
                                    this.page = 1;
                                    this.closeModalEditReceivableAccount();
                                    this.loadData();
                                }).catch(error => {
                                    this.isLoading = false;
                                    if (error.status == 422) {
                                        let response_errors = error.response.data.errors;
                                        this.errors = response_errors;
                                        this.enable_error_list = true;
                                    }
                                    handleRequestErrors(error.status);
                                })
                        }
                    }
                }
            )
        },
        updateRecurrence(event) {
            event.preventDefault();
            this.$confirm(
                {
                    message: this.receivable_account.total_installment > 0 ? 'Deseja atualizar a parcela?' : 'Deseja atualizar a recorrência?',
                    button: {
                        no: 'Não',
                        yes: 'Sim'
                    },

                    callback: confirm => {
                        if (confirm) {
                            this.isLoading = true;
                            api.post('/receivable-account/' + this.receivable_account.id + '/recurrence', this.receivable_account)
                                .then(() => {
                                    this.isLoading = false;
                                    this.$notify({
                                        title: "Sucesso",
                                        text: this.receivable_account.total_installment > 0 ? "Parcelamento atualizado com sucesso" : "Recorrência atualizada com sucesso",
                                        type: 'success'
                                    });
                                    this.page = 1;
                                    this.closeModalEditRecurrenceReceivableAccount();
                                    this.loadData();
                                }).catch(error => {
                                    this.isLoading = false;
                                    if (error.status == 422) {
                                        let response_errors = error.response.data.errors;
                                        this.errors = response_errors;
                                        this.enable_error_list = true;
                                    }
                                    handleRequestErrors(error.status);
                                })
                        }
                    }
                }
            )
        },
        liquidatedReceivableAccount(event) {
            event.preventDefault();
            this.$confirm(
                {
                    message: 'Confirma a liquidação da cobrança? Nota: uma vez liquidada, a cobrança em questão não pode ser revertida.',
                    button: {
                        no: 'Não',
                        yes: 'Sim'
                    },

                    callback: confirm => {
                        if (confirm) {
                            this.isLoading = true;
                            const formData = new FormData();
                            formData.append('payment_date', this.receivable_account.payment_date);
                            formData.append('bank_id', this.receivable_account.bank_id);
                            formData.append('amount', this.receivable_account.amount);
                            formData.append('method', this.receivable_account.method);
                            if (this.receivable_account.archive != null) {
                                formData.append('file', this.receivable_account.archive);
                            }
                            api.post('/receivable-account/' + this.receivable_account.id + '/manualReceivableAccountLiquidated', formData, {
                                headers: {
                                    'Content-Type': 'multipart/form-data',
                                }
                            })
                                .then(() => {
                                    this.isLoading = false;
                                    this.$notify({
                                        title: "Sucesso",
                                        text: "Cobrança liquidada com sucesso",
                                        type: 'success'
                                    });
                                    this.page = 1;
                                    this.closeModalLiquidatedReceivableAccount();
                                    this.loadData();
                                }).catch(error => {
                                    this.isLoading = false;
                                    if (error.status == 422) {
                                        let response_errors = error.response.data.errors;
                                        this.errors = response_errors;
                                        this.enable_error_list = true;
                                    }
                                    handleRequestErrors(error.status);
                                })
                        }
                    }
                }
            )
        },
        deleteReceivableAccount(id) {
            this.$confirm(
                {
                    message: 'Deseja cancelar a cobrança? Nota: uma vez removida, não é possível reverter a ação.',
                    button: {
                        no: 'Não',
                        yes: 'Sim'
                    },

                    callback: confirm => {
                        if (confirm) {
                            this.isLoading = true;
                            api.delete('/receivable-account/' + id)
                                .then(() => {
                                    this.isLoading = false;
                                    this.$notify({
                                        title: "Sucesso",
                                        text: "Receita removida com sucesso",
                                        type: 'success'
                                    });
                                    this.page = 1;
                                    this.loadData();
                                }).catch(error => {
                                    this.isLoading = false;
                                    handleRequestErrors(error.status);
                                })
                        }
                    }
                }
            )
        },
        enableEditOrDeleteReceivableAccount(receivable_account) {
            let enable = true;
            if (receivable_account.status == 'Erro'
                || receivable_account.status == 'Falha'
                || receivable_account.status == 'Paga'
                || receivable_account.status == 'Cancelada'
                || receivable_account.status == 'expired') {
                enable = false;
            }
            return enable;
        },
        enableEditOrDeleteRecurrenceReceivableAccount(receivable_account) {
            try{
                if(receivable_account.recurrence == ''){
                return false;
            }

            let enable = true;
            
            if (receivable_account.status == 'Erro'
                || receivable_account.status == 'Falha'
                || receivable_account.status == 'expired') {
                enable = false;
            } else if (receivable_account.recurrence == '') {
                enable = false;
            }

            let recurrence = receivable_account.recurrence;

            if (recurrence.total_installment > 0) {
                this.title_installment = 'Editar parcelamento';
            } 
            
            return enable;
            }catch(error ){
                console.log(error);
                return false;
            }
            
        },
        showModalEditReceivableAccount(receivable_account) {
            this.receivable_account.id = receivable_account.id;
            this.receivable_account.category_id = receivable_account.category.id;
            this.receivable_account.competence_date = receivable_account.competence_date;
            this.receivable_account.description = receivable_account.description;
            this.receivable_account.amount = receivable_account.total_receiver_formatted;
            this.receivable_account.discount = receivable_account.discount;
            this.receivable_account.fine = receivable_account.fine_formatted;
            this.receivable_account.interest = receivable_account.interest;
            this.receivable_account.cod_reference = receivable_account.cod_reference;
            this.receivable_account.due_date = receivable_account.due_date;
            this.receivable_account.observation = receivable_account.observation;
            this.$refs.observations_receivable_account.updateTextEditor(receivable_account.observation);
            this.category_multiselect = { 'key': receivable_account.category.id, 'value': receivable_account.category.name };
            this.modalDisplayEditReceivableAccount = 'block';
        },

        showModalEditRecurrenceReceivableAccount(receivable_account) {
            let recurrence = receivable_account.recurrence;
            this.receivable_account.id = recurrence.id;
            this.receivable_account.category_id = recurrence.category.id;
            this.receivable_account.description = recurrence.description;
            this.receivable_account.amount = recurrence.amount_formatted;
            this.receivable_account.discount = recurrence.discount;
            this.receivable_account.fine = recurrence.fine_formatted;
            this.receivable_account.interest = recurrence.interest;
            this.receivable_account.cod_reference = recurrence.cod_reference;
            this.receivable_account.total_installment = recurrence.total_installment;
            this.receivable_account.method = recurrence.method;
            this.receivable_account.interval_recurrence = recurrence.interval_recurrence;
            this.receivable_account.day_generate_receivable = recurrence.day_generate_receivable;
            this.installment_multiselect = { type: recurrence.total_installment, value: recurrence.total_installment == 1 ? 'À vista' : recurrence.total_installment + 'x' }
            this.receivable_account.observation = recurrence.observation;
            this.receivable_account.status = recurrence.status;
            this.$refs.observations_recurrence_receivable_account.updateTextEditor(recurrence.observation);
            this.category_multiselect = { 'key': recurrence.category.id, 'value': recurrence.category.name };
            if (recurrence.interval_recurrence == 'monthly') {
                this.interval_recurrence_multiselect = { type: recurrence.interval_recurrence, value: 'Mensal' };
            } else if (recurrence.interval_recurrence == 'bimonthly') {
                this.interval_recurrence_multiselect = { type: recurrence.interval_recurrence, value: 'Bimestral' };
            } else if (recurrence.interval_recurrence == 'quarterly') {
                this.interval_recurrence_multiselect = { type: recurrence.interval_recurrence, value: 'Trimestral' };
            } else if (recurrence.interval_recurrence == 'semiannual') {
                this.interval_recurrence_multiselect = { type: recurrence.interval_recurrence, value: 'Semestral' };
            } else if (recurrence.interval_recurrence == 'annual') {
                this.interval_recurrence_multiselect = { type: recurrence.interval_recurrence, value: 'Anual' };
            }

            if (recurrence.method == 'pix') {
                this.method_multiselect = { type: recurrence.method, value: 'PIX' }
            } else if (recurrence.method == 'ticket') {
                this.method_multiselect = { type: recurrence.method, value: 'Boleto' }
            } else if (recurrence.method == 'money') {
                this.method_multiselect = { type: recurrence.method, value: 'Dinheiro' }
            } else if (recurrence.method == 'other') {
                this.method_multiselect = { type: recurrence.method, value: 'Outros' }
            }

            this.bank_multiselect = { key: recurrence.bank.id, value: 'Conta: ' + capitalize(recurrence.bank.name) }

            if (recurrence.total_installment <= 0) {
                this.receivable_account.repeat = true;
                this.day_generate_receivable_multiselect = { type: recurrence.day_generate_receivable, value: recurrence.day_generate_receivable + 'º dia do mês' }
            } else if (recurrence.total_installment) {
                this.receivable_account.repeat = false;
            }
            this.modalDisplayEditRecurrenceReceivableAccount = 'block';
        },

        showModalLiquidatedReceivableAccount(receivable_account) {
            this.receivable_account.id = receivable_account.id;
            this.receivable_account.description = receivable_account.description;
            this.receivable_account.amount = receivable_account.total_receiver_formatted;
            this.receivable_account.bank_id = receivable_account.bank.id;
            this.receivable_account.status = receivable_account.status;
            this.receivable_account.client_name = receivable_account.client.name;
            this.receivable_account.client_document = receivable_account.client.document_formatted;
          
            this.bank_multiselect = { key: receivable_account.bank.id, value: 'Conta: ' + capitalize(receivable_account.bank.name) }
            if (receivable_account.method == 'pix') {
                this.method_multiselect = { type: receivable_account.method, value: 'PIX' }
            } else if (receivable_account.method == 'Boleto') {
                this.method_multiselect = { type: receivable_account.method, value: 'Boleto' }
            } else if (receivable_account.method == 'Dinheiro') {
                this.method_multiselect = { type: receivable_account.method, value: 'Dinheiro' }
            } else if (receivable_account.method == 'Outros') {
                this.method_multiselect = { type: receivable_account.method, value: 'Outros' }
            }
              this.receivable_account.method = receivable_account.method_original;
            
            this.modalDisplayLiquidatedReceivableAccount = 'block';
        },

        closeModalEditReceivableAccount() {
            this.receivable_account = {};
            this.errors = [];
            this.enable_error_list = false;
            this.$refs.observations_receivable_account.updateTextEditor('');
            this.modalDisplayEditReceivableAccount = 'none';
        },

        closeModalEditRecurrenceReceivableAccount() {
            this.receivable_account = {};
            this.errors = [];
            this.enable_error_list = false;
            this.$refs.observations_receivable_account.updateTextEditor('');
            this.modalDisplayEditRecurrenceReceivableAccount = 'none';
        },

        closeModalLiquidatedReceivableAccount() {
            this.receivable_account = {};
            this.modalDisplayLiquidatedReceivableAccount = 'none';
        },

         generateRandom() {
            return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, c =>
                (+c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> +c / 4).toString(16)
            );
        },

         downloadFile(receipt_id) {
            this.isLoading = true;
            api.get('/receivable-account/' + receipt_id + '/download', { responseType: 'blob' })
                .then((response) => {
                    const contentType = response.headers.get('Content-Type');
                    this.isLoading = false;
                    const blob = new Blob([response.data], { type: contentType })
                    const link = document.createElement('a')
                    link.href = URL.createObjectURL(blob);
                    link.download = 'download_' + this.generateRandom();
                    link.click()
                    URL.revokeObjectURL(link.href);
                }).catch(error => {
                    this.isLoading = false;
                    handleRequestErrors(error.status, error);
                })
        },

         async exportReceivableAccountXlsx() {
            this.isLoading = true;

            api.get('/receivable-account-export', {
                responseType: 'blob', params: {
                    'name': this.advanced_search_input.name,
                    'status': this.advanced_search_input.status,
                    'method': this.advanced_search_input.method,
                    'due_date_from': this.advanced_search_input.due_date_from,
                    'due_date_to': this.advanced_search_input.due_date_to,
                    'page': this.page
                }
            })
                .then((response) => {

                    this.isLoading = false;
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'receitas.xlsx');
                    document.body.appendChild(link);
                    link.click();
                    link.remove();

                }).catch(error => {
                    this.isLoading = false;
                    handleRequestErrors(error.status);
                })
        },

        async exportReceivableAccountJson() {
            this.isLoading = true;

            api.get('/receivable-account-export', {
                params: {
                    'name': this.advanced_search_input.name,
                    'status': this.advanced_search_input.status,
                    'method': this.advanced_search_input.method,
                    'due_date_from': this.advanced_search_input.due_date_from,
                    'due_date_to': this.advanced_search_input.due_date_to,
                    'page': this.page,
                    'type_export': 'json'
                },
                headers: {
                    'Accept': 'application/json; charset=UTF-8',
                    'charset': 'utf-8'
                }
            })
                .then((response) => {
                    this.isLoading = false;
                    const url = window.URL.createObjectURL(new Blob([response.data.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'receitas.json');
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                  
                }).catch(error => {
                    this.isLoading = false;
                    handleRequestErrors(error.status);
                })
        },


    },

    mounted() {
        this.url_api = process.env.VUE_APP_URL_API
        this.loadData();
        const response_categories = this.getCategories();
        const response_banks = this.getBank();
        response_categories.then(() => {
            this.categories_options = this.categories.map(item => ({
                key: item.id,
                value: item.name
            }));

        });
        response_banks.then(() => {
            this.banks_options = this.banks.map(item => ({

                key: item.id,
                value: 'Conta: ' + capitalize(item.name)
            }));
        });

    },
}
</script>

<style>


main {
    flex: 1 1 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

aside {
    flex: none;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #49b293;
    color: #fff;
    padding: 1em;
}

main div {
    text-align: center;
    color: #353539;
}

main span {
    padding: .5em 1em;
    margin: .5em;
    display: inline-block;
    background: #dedede;
}

aside a {
    color: inherit;
    text-decoration: none;
    font-weight: bold;
    display: inline-block;
    padding: .4em 1em;
}

td,
th,
tr {
    vertical-align: middle;
}
</style>